import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Product.scss';

export default function Monitors() {
  const [monitors, setMonitors] = useState([]);

  useEffect(() => {
    async function fetchData() {
      try {
        const res = await fetch(
          'https://sheets.googleapis.com/v4/spreadsheets/1usVfJ-1O_wRD5fcLxVQVfskcSQ-L6hmDp2kvFckvGO8/values/Лист1!A:F?key=AIzaSyAbLqcy6h2MPUSuWJh93fUax3NIAUPtgv8'
        );
        const data = await res.json();

        const rows = data.values;
        if (!rows || rows.length < 2) return;

        const headers = rows[0];
        const items = rows.slice(1).map((row) => {
          const obj = {};
          headers.forEach((h, i) => (obj[h.trim().toLowerCase()] = row[i] || ''));
          return obj;
        });

        // фильтруем по категории "monitors"
        const monitorItems = items.filter(
          (item) => item.category?.trim().toLowerCase() === 'monitors'
        );

        setMonitors(monitorItems);
      } catch (err) {
        console.error('Ошибка при загрузке данных:', err);
      }
    }

    fetchData();
  }, []);

  return (
    <div className="products">
      <h1>Мониторы</h1>
      <div className="products__list">
        {monitors.length > 0 ? (
          monitors.map((monitor) => (
            <div key={monitor.id} className="products__card">
              <img src={monitor.image} alt={monitor.name} />
              <h2>{monitor.name}</h2>
              <p className="specs">{monitor.description}</p>
              <p className="price">{monitor.price}</p>
              <Link to={`/components/monitors/${monitor.id}`} className="btn">
                Подробнее
              </Link>
            </div>
          ))
        ) : (
          <p>Загрузка...</p>
        )}
      </div>
    </div>
  );
}
